var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('investor-form',{attrs:{"investor":_vm.investor},on:{"updateCodes":_vm.getIfB3Codes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }